import React, {ReactNode} from "react";
import {observer} from "mobx-react-lite";
import classNames from "classnames";


import "./FormHint.css"


interface FormHintProps {
    title?: string
    icon: ReactNode,
    text: string,
    className?: string,
    size?: "small" | "medium"
    type?: "neutral" | "error"
}

export const FormHint = observer(
    (
        {
            title,
            icon,
            text,
            type = "neutral",
            size,
            className,
        }: FormHintProps
    ) => {
        return (
            <div className={classNames({
                "FormHint": true,
                [className!]: className
            })}>
                {title &&
                    <div className={classNames({
                        "FormHint__title title-medium": true,
                        "title-small": size === "small"
                    })}>
                        {title}
                    </div>
                }
                <div className={classNames({
                    "FormHint__text body-medium": true,
                    "FormHint__text--error label-large": type === "error",
                    "body-small": size === "small"
                })}>
                    {icon}
                    {text}
                </div>
            </div>
        )
    }
)
